// extracted by mini-css-extract-plugin
module.exports = {"ks":"JournalActingKsIcon_ks__2I5dC","activeKs":"JournalActingKsIcon_activeKs__385dQ"};